// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__1kWHv","tooltip":"Tooltip_tooltip__z4Bh1"};